
const snackbar = {
    namespaced: true,
    state: {
        msg: '',
        visible: false
    },
    mutations: {
        SHOW_SNACKBAR: (state, options) => {
            state.visible = true;
            state.msg = options.msg;
        },
        ClOSE_SNACKBAR: (state) => {
            state.visible = false;
        }
    },
    actions: {
        openMsg(context, options) {
            context.commit('SHOW_SNACKBAR', {
                msg: options.msg
            })

            if (options.timeout) {
                setTimeout(() => {
                    context.commit('ClOSE_SNACKBAR')
                }, options.timeout)
            }
        }
    }
}

export default snackbar;